export const routeList = {
    HOME_PAGE: "/",
    HOME_PAGE_2: "/home",
    LOGIN_PAGE: "/login",
    SIGNUP_PAGE: "/signup",

    LEARN_PAGE: "/learn-page",
    LEARN_COURSES_PAGE: "/learn/courses?tab=1",
    LEARN_MY_COURSES_PAGE: "/learn/courses?tab=2",
    LEARN_MOST_POPULAR_COURSES: "/learn/courses?tab=3",
    LEARN_LEARNING_PATH_PAGE: "/learn/learningpath",
    LEARN_MY_LP_PAGE: "/learn/courses?tab=4",
    LEARN_MY_OBLP_PAGE: "/learn/courses?tab=5",
    LEARN_VIDEOS_PAGE: "/learn/videos",
    // LEARN_LEARNING_PATH_PAGE: "/learn/learningpath",
    LEARN_CERTIFICATIONS_PAGE: "/learn/certifications",
    LEARN_EVENTS_PAGE: "/learn/events",
    LEARN_COACHING_PAGE: "/learn/coaching",
    LEARN_ROLEPLAY_PAGE: "/learn/roleplay",
    LEARN_OTHERS_PAGE: "/learn/others",
    LEARN_COMBO_PAGE: "/learn/combo",

    SUBSCRIPTION_PAGE: "/subscription",
    PAYMENT_PAGE_SUBSCRIPTION: "/subscription/checkout?type=subscription",
    COACHING_CHECKOUT_PAGE: "/coaching/checkout",
    VIEW_SUBSCRRIPTION_RECEIPT: "/subscription/view/receipt",

    CART_PAGE: "/product/cart",
    PAYMENT_PAGE_PRODUCT: "/product/checkout",

    PAYMENT_UPDATE_PAGE: "/payment/update",
    PAYMENT_UPDATE_MOBILE_PAGE:"/payment/update-mobile",
    PAYMENT_SUMMARY: "/payment-summary",
}